import { createStore } from 'vuex'
const URL = 'https://server-web.konaweselatankab.go.id/';
const URL_SIMPEG = 'https://server-egov.konaweselatankab.go.id/';

export default createStore({
  state: {
    URL_APP             : URL,
    URL_APP_SIMPEG      : URL_SIMPEG,

    URL_SLIDER          : URL + "api/v1/publish_diskertrans_slider/", //✅
    URL_SAMBUTAN        : URL + "api/v1/publish_diskertrans_sambutan/", //✅
    ADD_URL_BERITA      : URL + "api/v1/web_publish_berita/", 
  

    ADD_URL_TUGAS       : URL + "api/v1/publish_diskertrans_tugas_pokok/", //✅
    ADD_URL_STRUKTUR    : URL + "api/v1/publish_diskertrans_struktur_organisasi/", //✅
    TUJUAN_SASARAN      : URL + "api/v1/publish_diskertrans_tujuan_sasaran/", //✅ 


    ADD_URL_UNIT_KERJA  : URL + "api/v1/publish_diskertrans_unit_kerja/", //✅

    ADD_URL_PROFIL      : URL + "api/v1/publish_koperasi_umkm_profil_kantor/", 
    ADD_URL_PEGAWAI     : URL + "api/v1/publish_koperasi_umkm_profilstruktural/", 
    PROFILE_PEGAWAI     : URL + "api/v1/publish_disperindag_profilePegawai/",  

    // DATA1             : URL + "api/v1/publish_diskertrans_data_umum/", 

    DATA1           :   URL +    "api/v1/publish_diskertrans_data_umum/",		
    DATA2      :   URL +    "api/v1/publish_diskertrans_perizinan/",
    DATA3           :   URL +   "api/v1/publish_diskertrans_ppid/",
    DATA4            :  URL +  	"api/v1/publish_diskertrans_umk/",
    DATA5           :   URL +   "api/v1/publish_diskertrans_uptd/",


    LAYANAN1           :   URL +   "api/v1/publish_diskertrans_pekerjaan/",
    LAYANAN2           :   URL +   "api/v1/publish_diskertrans_peraturan/",
    LAYANAN3           :   URL +   "api/v1/publish_diskertrans_hubungan_industri/",
    LAYANAN4           :   URL +   "api/v1/publish_diskertrans_pelatihan_kerja/",
    LAYANAN5           :   URL +   "api/v1/publish_diskertrans_penempatan_tenaga_kerja/",
    LAYANAN6           :   URL +   "api/v1/publish_diskertrans_pengawasan_ketenagakerjaan/",

	// Pekerjaan		api/v1/publish_diskertrans_pekerjaan/view
	// Peraturan		api/v1/publish_diskertrans_peraturan/view	{"data_ke":1,"cari_value":"","kategori":"RPJMN"}
	// Hubungan Industri	api/v1/publish_diskertrans_hubungan_industri/view	
	// Pelatihan Kerja		api/v1/publish_diskertrans_pelatihan_kerja/view
	// Penempatan Tenaga Kerja	api/v1/publish_diskertrans_penempatan_tenaga_kerja/view
	// Pengawasan Tenaga Kerja	api/v1/publish_diskertrans_pengawasan_ketenagakerjaan/view
 

    // DOKUMEN_LAINNYA        : URL + "api/v1/publish_damkar_dokumen/",

    // LAYANAN_1         : URL + "api/v1/publish_dinsos_layanan/", 
    INFORMASI_1         : URL + "api/v1/publish_dinsos_peraturan/", 
    KONTAK_1          : URL + "api/v1/publish_dinsos_kontak/", 



    // LAYANAN_PASAR         : URL + "api/v1/publish_izinpasarIndustri/",
    // LAYANAN_PAMERAN       : URL + "api/v1/publish_izinpameranIndustri/",
    // LAYANAN_IZINLIAR      : URL + "api/v1/publish_izinliarIndustri/",
    // LAYANAN_GUDANG        : URL + "api/v1/publish_daftargudangIndustri/",
    // LAYANAN_WARALABA      : URL + "api/v1/publish_daftarwarabalaIndustri/",

    URL_UNIT_KERJA              : URL + "api/v1/publish_dinsos_unit_kerja/",


    URL_DOKUMEN           : URL + "api/v1/web_publish_dokumen_OPD/",
    URL_DATA              : URL + "api/v1/publish_koperasi_umkm_data/",

    DATA_PERMOHONAN       : URL + "api/v1/publish_distributorIndustri/", 


    ADD_URL_LINK_TERKAIT      : URL + "api/v1/web_publish_link_terkait/",




    // ADD_FOTO_HOME: URL + "api/v1/publish_dinsos_foto/home/",
    ADD_FOTO: URL + "api/v1/publish_diskertrans_foto/",
    ADD_VIDEO: URL + "api/v1/publish_diskertrans_video/",
    FILE_LOAD : URL + "uploads/",
    UNIT_KERJA: '9emCdG8CwXXY2ws6f',
    TAHUN: '2019'
  }
})